export default "__VITE_ASSET__CmWoZ_sl__"